// /utils/forceHardReload.js
// True force-refresh equivalent of Ctrl+Shift+R:
// clear SW + Cache API + app snapshots, then navigate through a same-origin
// endpoint that sends Clear-Site-Data: "cache" before redirecting back.

import { markFrontendReloadAttempt } from "./frontendReloadGuard";
import { clearAppCachesBeforeReload } from "./clearAppCachesBeforeReload";

function currentReturnPath() {
  const url = new URL(window.location.href);
  url.searchParams.delete("_hr");
  return `${url.pathname}${url.search}${url.hash}` || "/";
}

function bustedDocumentUrl() {
  const url = new URL(window.location.href);
  url.searchParams.set("_hr", String(Date.now()));
  return url.toString();
}

async function clearServiceWorkersAndCacheStorage() {
  if ("serviceWorker" in navigator) {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((reg) => reg.unregister()));
    } catch (err) {
      console.warn("[forceHardReload] service worker unregister failed:", err);
    }
  }

  if ("caches" in window) {
    try {
      const names = await caches.keys();
      await Promise.all(names.map((name) => caches.delete(name)));
    } catch (err) {
      console.warn("[forceHardReload] Cache API clear failed:", err);
    }
  }
}

/**
 * Hard-reload the SPA so users pick up a newly deployed frontend bundle
 * (JS, CSS, HTML, lazy chunks) without needing a manual force refresh.
 */
export async function forceHardReload() {
  if (typeof window === "undefined") return;

  markFrontendReloadAttempt();
  clearAppCachesBeforeReload();
  await clearServiceWorkersAndCacheStorage();

  const returnPath = currentReturnPath();
  const clearUrl = `/api/system/frontend-hard-reload?return=${encodeURIComponent(returnPath)}`;

  // Full document navigation (not fetch): Clear-Site-Data is reliable on navigations.
  try {
    window.location.replace(clearUrl);
    return;
  } catch (err) {
    console.warn("[forceHardReload] clear-site navigation failed:", err);
  }

  window.location.replace(bustedDocumentUrl());
}
